"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseCountries = require("nicbase-countries");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _yup = require("yup");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getSchema = function getSchema(isNonEuCountry) {
  return (0, _yup.object)().shape({
    vat: (0, _yup.string)().min(1).max(isNonEuCountry ? 50 : 14).required()
  });
}; // Tax ID configuration for countries that bypass EU VAT validation.
// Maps country code to a translation key prefix and label key.
// Countries sharing the same tax ID type share the same prefix.


var NON_EU_TAX_ID_CONFIG = {
  // North America (NPI-278)
  US: {
    prefix: 'dotCheck',
    label: 'dot'
  },
  CA: {
    prefix: 'mcCheck',
    label: 'mc'
  },
  // Latin America & Caribbean (NPI-2756)
  MX: {
    prefix: 'rfcCheck',
    label: 'rfc'
  },
  BR: {
    prefix: 'cnpjCheck',
    label: 'cnpj'
  },
  AR: {
    prefix: 'cuitCheck',
    label: 'cuit'
  },
  CL: {
    prefix: 'rutCheck',
    label: 'rut'
  },
  UY: {
    prefix: 'rutCheck',
    label: 'rut'
  },
  CO: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  GT: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  SV: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  BO: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  CU: {
    prefix: 'nitCheck',
    label: 'nit'
  },
  PE: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  EC: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  NI: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  PA: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  PY: {
    prefix: 'rucCheck',
    label: 'ruc'
  },
  CR: {
    prefix: 'cedulaCheck',
    label: 'cedula'
  },
  HN: {
    prefix: 'rtnCheck',
    label: 'rtn'
  },
  DO: {
    prefix: 'rncCheck',
    label: 'rnc'
  },
  PR: {
    prefix: 'dotCheck',
    label: 'dot'
  },
  VI: {
    prefix: 'dotCheck',
    label: 'dot'
  },
  TT: {
    prefix: 'birCheck',
    label: 'bir'
  },
  JM: {
    prefix: 'trnCheck',
    label: 'trn'
  },
  VE: {
    prefix: 'rifCheck',
    label: 'rif'
  },
  HT: {
    prefix: 'nifCheck',
    label: 'nif'
  },
  GY: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  BB: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  SR: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  LC: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  AG: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  BZ: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  GD: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  KN: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  DM: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  VC: {
    prefix: 'tinCheck',
    label: 'tin'
  },
  BS: {
    prefix: 'businessLicenseCheck',
    label: 'businessLicense'
  },
  TC: {
    prefix: 'businessLicenseCheck',
    label: 'businessLicense'
  },
  AI: {
    prefix: 'businessLicenseCheck',
    label: 'businessLicense'
  },
  AW: {
    prefix: 'cribCheck',
    label: 'crib'
  },
  KY: {
    prefix: 'businessRegCheck',
    label: 'businessReg'
  },
  GF: {
    prefix: 'siretCheck',
    label: 'siret'
  },
  MQ: {
    prefix: 'siretCheck',
    label: 'siret'
  },
  GP: {
    prefix: 'siretCheck',
    label: 'siret'
  },
  MF: {
    prefix: 'siretCheck',
    label: 'siret'
  },
  VG: {
    prefix: 'companyRegCheck',
    label: 'companyReg'
  }
};

var VatCheckForm = function VatCheckForm(_ref) {
  var intl = _ref.intl,
      onNextClick = _ref.onNextClick;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isValid = _useState2[0],
      setIsValid = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      waiting = _useState4[0],
      setWaiting = _useState4[1];

  var _useState5 = (0, _react.useState)({
    country: 'DE',
    vat: '',
    vatAlreadyExists: false,
    valid: true
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      inputs = _useState6[0],
      setInputs = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      label = _useState8[0],
      setLabel = _useState8[1];

  var _useState9 = (0, _react.useState)('check'),
      _useState10 = _slicedToArray(_useState9, 2),
      check = _useState10[0],
      setCheck = _useState10[1];

  var _useState11 = (0, _react.useState)(''),
      _useState12 = _slicedToArray(_useState11, 2),
      top = _useState12[0],
      setTop = _useState12[1];

  var _useState13 = (0, _react.useState)(''),
      _useState14 = _slicedToArray(_useState13, 2),
      bottom = _useState14[0],
      setBottom = _useState14[1];

  (0, _react.useEffect)(function () {
    var config = NON_EU_TAX_ID_CONFIG[inputs.country];

    if (config) {
      var prefix = config.prefix,
          labelKey = config.label;
      setLabel( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.".concat(prefix, ".").concat(labelKey),
        tagName: "span"
      }));
      setCheck( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.proceed.button"
      }));
      setTop( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.".concat(prefix, ".header.left.middle"),
        tagName: "span"
      }));
      setBottom( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.".concat(prefix, ".hint")
      }, function (value) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-gray-500 text-sm"
        }, value);
      }));
    } else {
      setLabel( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.vatCheck.vat",
        tagName: "span"
      }));
      setCheck( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.vatCheck.button"
      }));
      setTop( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.vatCheck.header.left.middle",
        tagName: "span"
      }));
      setBottom( /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "portal.registration.vatCheck.hint"
      }, function (value) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-gray-500 text-sm"
        }, value);
      }));
    }
  }, [inputs.country]);
  var timeoutRef = (0, _react.useRef)();

  var handleClick = function handleClick() {
    setWaiting(true);
    fetch("".concat(ENV.vatValidationRestAPI, "?vat=").concat(inputs.vat, "&country=").concat(inputs.country), {
      method: 'GET'
    }).then(function (response) {
      if (response.ok || NON_EU_TAX_ID_CONFIG[inputs.country]) {
        // disabling VAT check for non-EU countries (US, CA, and LAC countries)
        response.json().then(function (e) {
          timeoutRef.current = setTimeout(function () {
            onNextClick(_objectSpread(_objectSpread({}, e), {}, {
              valid: true
            }));
          }, 1400);
        });
      } else if (response.status === 400) {
        timeoutRef.current = setTimeout(function () {
          setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
            valid: false
          }));
          setWaiting(false);
        }, 1400);
      } else {
        // If we get here, an error occured during vat check. Probably the EU vat check API isn't responding or has an error.
        // We treat these error as "vat is valid".
        timeoutRef.current = setTimeout(function () {
          onNextClick({
            address: {
              countrycode: inputs.country
            },
            vat: inputs.vat,
            valid: true
          });
        }, 1400);
      }
    })["catch"](function () {
      // The VAT check request failed for some reason. We ignore it in that case.
      timeoutRef.current = setTimeout(function () {
        onNextClick({
          address: {
            countrycode: inputs.country
          },
          vat: inputs.vat,
          valid: true
        });
      }, 1400);
    });
  };

  (0, _react.useEffect)(function () {
    return function () {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  var firstUpdate = (0, _react.useRef)(true);

  if (firstUpdate.current) {
    firstUpdate.current = false;
  }

  (0, _react.useEffect)(function () {
    try {
      if (getSchema(!!NON_EU_TAX_ID_CONFIG[inputs.country]).validateSync(inputs)) {
        setIsValid(true);
      }
    } catch (e) {
      setIsValid(false);
    }
  }, [inputs]);

  if (waiting) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex bg-cyan-500 justify-around items-center h-full w-full text-primary"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "sm:w-1/2 lg:w-1/3 xl:w-1/4 bg-white pt-5 pl-12 pr-12 pb-5 flex flex-col text-base rounded"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicplaceLogo, {
      height: "90",
      width: "280",
      className: "self-center mb-10"
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinner, null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-2/5 text-base text-white font-bold"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.vatCheck.header.right"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement("h3", {
        className: "uppercase text-4xl mb-8"
      }, value);
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.vatCheck.text.right"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement("h4", {
        className: "text-xl mb-8"
      }, value);
    })));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex bg-cyan-500 justify-around items-center h-full w-full text-primary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-1/4 bg-white pt-5 pl-12 pr-12 pb-5 flex flex-col text-base rounded"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicplaceLogo, {
    height: "90",
    width: "280",
    className: "self-center mb-10"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.vatCheck.header.left.start"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold mb-5"
    }, value);
  }), top, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.vatCheck.text.left"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mt-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.vatCheck.link.left"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: "https://auth.my.nic-place.com/login",
      className: "mb-5 underline"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Dropdown, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "portal.registration.vatCheck.dropdown.label",
      tagName: "span"
    }),
    source: Object.keys(_nicbaseCountries.CountryCodeMapping).map(function (key) {
      return {
        value: key,
        label: intl.formatMessage({
          id: _nicbaseCountries.CountryCodeMapping[key]
        })
      };
    }).sort(function (a, b) {
      return a.label.localeCompare(b.label);
    }),
    value: inputs.country,
    onChange: function onChange(key) {
      return setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        country: key
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: inputs.vat,
    onChange: function onChange(e) {
      return setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
        vat: e.toUpperCase()
      }));
    },
    label: label,
    className: "flex-1",
    required: true
  }), !inputs.valid ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.vatCheck.warning"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-red-600 text-sm"
    }, value);
  }) : /*#__PURE__*/_react["default"].createElement("span", null, bottom), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    disabled: !isValid,
    onClick: handleClick,
    className: "mb-2 self-center mt-10",
    primary: true,
    raised: true
  }, check)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden sm:block w-2/5 text-base text-white font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.vatCheck.header.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "uppercase text-4xl mb-8"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.vatCheck.text.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h4", {
      className: "text-xl mb-8"
    }, value);
  })));
};

var noop = function noop() {};

VatCheckForm.propTypes = {
  intl: _nicbaseTranslation.intlShape.isRequired,
  onNextClick: _propTypes["default"].func
};
VatCheckForm.defaultProps = {
  onNextClick: noop
};

var _default = (0, _nicbaseTranslation.injectIntl)(VatCheckForm);

exports["default"] = _default;